import React from "react";
import { Box, CircularProgress } from "@mui/material";
import { Column } from "../types";
import { TableCell } from "./TableCell";
import { mergeCellStyles } from "./mergeCellStyles";

interface Props<Data extends Record<string, any>, Context extends any = any> {
  context: Context;
  loading: boolean;
  tableData: Data[];
  columns: Column<Data, Context>[];
}

export const TableBody = <Data extends Record<string, any>, Context extends any = any>({
  columns,
  loading,
  context,
  tableData,
}: Props<Data, Context>) => {
  if (loading)
    return (
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "10rem" }}>
        <CircularProgress />
      </Box>
    );

  return (
    <Box>
      {tableData.map((row, rowIndex) => (
        <Box
          key={row?.id ?? `row_${rowIndex}`}
          sx={{
            display: "grid",
            gridTemplateColumns: columns.map(col => col.width || "1fr").join(" "),
          }}>
          {columns.map((column, columnIndex) => (
            <TableCell
              key={`${column.renderKey.toString()}_${rowIndex}_${columnIndex}`}
              column={column}
              context={context}
              sx={mergeCellStyles(column?.cellStyles, column?.bodyStyles)}>
              {column.renderCell
                ? column.renderCell({
                    row,
                    column,
                    columns,
                    context,
                    rowIndex,
                    columnIndex,
                    value: row[column.renderKey],
                    existingColumnsTypes: columns.map(({ columnType }) => columnType).filter(Boolean) as string[],
                  })
                : column?.formatter
                  ? column.formatter(row[column.renderKey])
                  : row[column.renderKey]}
            </TableCell>
          ))}
        </Box>
      ))}
    </Box>
  );
};
